import './bhospitalityco2/style';
import FormStructure from './bhospitalityco2/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js